import ConditionalComponent from './ConditionalComponent'

export{
    ConditionalComponent
}
